import { AiFillGithub, AiOutlineTwitter, AiFillInstagram } from "react-icons/ai";
import { FaFacebook, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const socials = [
    {
        href: "https://github.com/roysuzon",
        icon: AiFillGithub
    },
    {
        href: "https://www.linkedin.com/in/roybd/",
        icon: FaLinkedinIn
    },
    {
        href: "https://twitter.com/roysuzonn",
        icon: AiOutlineTwitter
    },
    {
        href: "https://www.instagram.com/roysuzonn",
        icon: AiFillInstagram
    },
    {
        href: "https://www.facebook.com/mr.suzon",
        icon: FaFacebook
    },
    {
        href: "https://wa.me/+8801540401185",
        icon: FaWhatsapp
    }
];

export default socials;
